import { useEffect } from "react";

export function useScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);
}

export function useScrollToTopOnChange(value) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [value]);
}